module.exports = __webpack_public_path__ + "static/media/arrowup.549a78ae.webp";